import { t } from '@lingui/macro';
import React from 'react';
import { withDisplayedLayersCheck } from '../../../HOC/withDisplayedLayersCheck';
import { LegendRenderer } from '../../LegendRenderer';
import { CUR_PROFICIT_SCOOTERS_LEGEND } from '../../../constants/legends';

const CurProficitLegendComponent = () => (
    <LegendRenderer config={CUR_PROFICIT_SCOOTERS_LEGEND} />
);

export const CurProficitLegend = withDisplayedLayersCheck(CurProficitLegendComponent, t`Текущий избыток самокатов`);
